module.exports = __webpack_public_path__ + "static/media/liveroom-setting-wx.63cbf8ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-wx.png
// module id = 2047
// module chunks = 6